// Pricing helpers shared across the storefront.

/**
 * Per-unit price for a product sold in fixed multiples.
 *
 * Supplier prices are quoted per sell-unit (e.g. per pack of 10); the quantity
 * selector counts base units, so the price of a single unit is the sell-unit
 * price divided by the pack multiple. `multiple` defaults to 1, so this is a
 * no-op for normal products (the vast majority).
 *
 * This is the single definition of the per-unit rule for all live surfaces
 * (supplier card, product detail, cart, checkout).
 */
export const perUnitPrice = (
  price: number,
  multiple: number | null | undefined,
): number => price / (multiple || 1)

/**
 * Round a monetary value to whole pennies (half up), matching the backend's
 * per-line Decimal rounding (ROUND_HALF_UP).
 *
 * Round each line with this before summing, so a previewed total equals the sum
 * of the rounded lines the user sees — the same round-then-sum the server
 * persists. The 1e-9 nudge corrects binary-float error (e.g. 1.005 is stored as
 * 1.00499999…) so a genuine half rounds up instead of sticking a penny low.
 */
export const roundToPenny = (value: number): number =>
  Math.round((value + 1e-9) * 100) / 100
